export interface Movie {
  id: string;
  title: string;
  titleEn?: string;
  slug: string;
  category: string;
  categorySlug: string;
  poster: string;
  rating: number;
  year: number;
  quality: string;
  duration: string;
  region: string;
  description: string;
  director: string;
  cast: string[];
  tags: string[];
  featured: boolean;
  trending: boolean;
  newRelease: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '动作片', slug: 'action' },
  { name: '喜剧片', slug: 'comedy' },
  { name: '爱情片', slug: 'romance' },
  { name: '科幻片', slug: 'scifi' },
  { name: '恐怖片', slug: 'horror' },
  { name: '剧情片', slug: 'drama' },
  { name: '动画片', slug: 'animation' },
  { name: '纪录片', slug: 'documentary' },
  { name: '电视剧', slug: 'tv-series' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    slug: 'the-wandering-earth-3',
    category: '科幻片',
    categorySlug: 'scifi',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20futuristic%20spaceship%20flying%20through%20cosmic%20nebula%20with%20orange%20and%20gold%20warm%20tones%2C%20dramatic%20lighting%2C%20sci-fi%20epic%20film%20poster%20aesthetic%2C%20Chinese%20sci-fi%20movie%20poster%20design%2C%20clean%20minimalist%20composition%2C%20dark%20background%20with%20vibrant%20cosmic%20colors&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    rating: 8.5,
    year: 2024,
    quality: '4K 超清',
    duration: '148分钟',
    region: '中国大陆',
    description: '太阳急速老化，持续膨胀，一百年后将吞没地球。为了生存，人类开启"流浪地球"计划，倾全球之力建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的新家园。在这场跨越两千五百年的漫长旅程中，人类将面临前所未有的挑战。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    tags: ['科幻', '灾难', '太空', '硬核科幻'],
    featured: true,
    trending: true,
    newRelease: true,
  },
  {
    id: '2',
    title: '满江红',
    titleEn: 'Full River Red',
    slug: 'full-river-red',
    category: '剧情片',
    categorySlug: 'drama',
    poster: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20film%20poster%20style%2C%20ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20red%20lanterns%2C%20dark%20mysterious%20atmosphere%2C%20golden%20warm%20accents%2C%20clean%20cinematic%20composition%2C%20period%20drama%20aesthetic&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    rating: 8.8,
    year: 2023,
    quality: '4K 超清',
    duration: '159分钟',
    region: '中国大陆',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均被裹挟进这场巨大的阴谋之中，宰相秦桧限两人在一个时辰之内找到凶手。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    tags: ['悬疑', '历史', '古装', '剧情'],
    featured: true,
    trending: true,
    newRelease: false,
  },
  {
    id: '3',
    title: '长安三万里',
    titleEn: 'Chang An',
    slug: 'chang-an',
    category: '动画片',
    categorySlug: 'animation',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20poster%2C%20ancient%20Tang%20Dynasty%20cityscape%20with%20golden%20palace%20rooftops%20against%20starry%20night%20sky%2C%20poetic%20and%20dreamy%20atmosphere%2C%20warm%20golden%20and%20amber%20lighting%2C%20traditional%20Chinese%20painting%20style%20blended%20with%20modern%20animation&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    rating: 8.3,
    year: 2023,
    quality: '4K 超清',
    duration: '168分钟',
    region: '中国大陆',
    description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。两位伟大诗人跌宕起伏的命运，将那个诗酒纵横、气度恢弘的大唐盛世画卷徐徐展开。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    tags: ['动画', '历史', '诗歌', '传记'],
    featured: true,
    trending: false,
    newRelease: false,
  },
  {
    id: '4',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    slug: 'no-more-bets',
    category: '剧情片',
    categorySlug: 'drama',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20style%2C%20dark%20gritty%20alley%20in%20Southeast%20Asia%20with%20neon%20signs%2C%20mysterious%20silhouette%20figure%2C%20tense%20atmosphere%2C%20warm%20neon%20lights%20against%20dark%20background%2C%20clean%20cinematic%20composition&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    rating: 8.1,
    year: 2023,
    quality: '蓝光 1080P',
    duration: '130分钟',
    region: '中国大陆',
    description: '程序员潘生与模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，套现并完成业绩。警察赵东冉跨国追查，最终将犯罪团伙一网打尽。',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    tags: ['犯罪', '剧情', '悬疑', '社会'],
    featured: false,
    trending: true,
    newRelease: true,
  },
  {
    id: '5',
    title: '封神第一部',
    titleEn: 'Creation of the Gods I',
    slug: 'creation-of-the-gods-1',
    category: '动作片',
    categorySlug: 'action',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%2C%20ancient%20Chinese%20warrior%20on%20horseback%20with%20flowing%20banner%2C%20epic%20battlefield%20with%20dramatic%20clouds%2C%20golden%20and%20crimson%20warm%20tones%2C%20mythological%20Chinese%20aesthetic%2C%20clean%20heroic%20composition&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    rating: 8.2,
    year: 2023,
    quality: '4K 超清',
    duration: '148分钟',
    region: '中国大陆',
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。各方势力暗流涌动，风云变幻端倪初现。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    tags: ['奇幻', '动作', '神话', '史诗'],
    featured: true,
    trending: true,
    newRelease: false,
  },
  {
    id: '6',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    slug: 'yolo',
    category: '喜剧片',
    categorySlug: 'comedy',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20style%2C%20boxing%20ring%20with%20warm%20spotlight%2C%20inspiring%20and%20uplifting%20vibe%2C%20golden%20and%20amber%20lighting%2C%20clean%20minimalist%20cinematic%20poster%20design%2C%20warm%20toned%20sports%20theme&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    rating: 7.9,
    year: 2024,
    quality: '蓝光 1080P',
    duration: '129分钟',
    region: '中国大陆',
    description: '乐莹是一个善良的女孩，但生活却屡屡受挫。在经历了亲情、爱情、友情的多重打击后，她选择通过拳击运动重新找回自我。从一个唯唯诺诺的"老好人"，到在拳击台上挥洒汗水的拳击手，乐莹完成了一次华丽蜕变。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    tags: ['喜剧', '运动', '励志', '剧情'],
    featured: false,
    trending: true,
    newRelease: true,
  },
  {
    id: '7',
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    slug: 'lost-in-the-stars',
    category: '剧情片',
    categorySlug: 'drama',
    poster: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%2C%20woman%20silhouette%20against%20tropical%20ocean%20sunset%2C%20dramatic%20crimson%20and%20gold%20sky%2C%20suspenseful%20atmosphere%2C%20clean%20cinematic%20poster%20design%2C%20mysterious%20and%20elegant%20composition&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    rating: 8.0,
    year: 2023,
    quality: '4K 超清',
    duration: '121分钟',
    region: '中国大陆',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。在他苦寻无果之时，一个陌生女人突然出现，声称自己就是李木子。何非被一步步拖入精心设计的陷阱，真相如层层迷雾，而海底的星空下，隐藏着最残酷的答案。',
    director: '崔睿',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    tags: ['悬疑', '犯罪', '剧情', '反转'],
    featured: false,
    trending: false,
    newRelease: false,
  },
  {
    id: '8',
    title: '熊出没·逆转时空',
    titleEn: 'Boonie Bears: Time Twist',
    slug: 'boonie-bears-time-twist',
    category: '动画片',
    categorySlug: 'animation',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%2C%20two%20cartoon%20bears%20in%20futuristic%20time%20travel%20scene%2C%20colorful%20vibrant%20warm%20tones%2C%20playful%20and%20adventurous%20composition%2C%20children%20animation%20film%20poster%20design%2C%20clean%20and%20fun%20aesthetic&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    rating: 7.5,
    year: 2024,
    quality: '4K 超清',
    duration: '108分钟',
    region: '中国大陆',
    description: '光头强是一名普通程序员，却常梦见陌生的森林和两只狗熊。直到一次意外穿越，他来到一个平行时空，发现自己竟是"熊出没"世界的破坏者。为纠正错误，光头强与熊大熊二展开了一场穿越时空的冒险。',
    director: '林汇达',
    cast: ['谭笑', '张伟', '张秉君'],
    tags: ['动画', '喜剧', '冒险', '家庭'],
    featured: false,
    trending: false,
    newRelease: true,
  },
  {
    id: '9',
    title: '坚如磐石',
    titleEn: 'Under the Light',
    slug: 'under-the-light',
    category: '剧情片',
    categorySlug: 'drama',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20drama%20film%20poster%2C%20dark%20city%20skyline%20at%20night%20with%20rain%2C%20neon%20reflections%20on%20wet%20street%2C%20mysterious%20figure%20in%20shadow%2C%20tense%20and%20gritty%20atmosphere%2C%20warm%20street%20lights%20contrasting%20darkness%2C%20cinematic%20noir%20style&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    rating: 7.8,
    year: 2023,
    quality: '蓝光 1080P',
    duration: '127分钟',
    region: '中国大陆',
    description: '供职于市局刑事鉴定中心的青年警察苏见明，为保护人民群众的安全，开始了一趟惊心动魄的侦查之旅。一场看似普通的公交车爆炸案，牵扯出背后盘根错节的利益集团，正义与罪恶的较量一触即发。',
    director: '张艺谋',
    cast: ['雷佳音', '张国立', '于和伟', '周冬雨'],
    tags: ['犯罪', '剧情', '悬疑', '警匪'],
    featured: false,
    trending: false,
    newRelease: false,
  },
  {
    id: '10',
    title: '飞驰人生2',
    titleEn: 'Pegasus 2',
    slug: 'pegasus-2',
    category: '喜剧片',
    categorySlug: 'comedy',
    poster: 'https://readdy.ai/api/search-image?query=Racing%20movie%20poster%20style%2C%20rally%20car%20speeding%20through%20desert%20dust%20at%20sunset%2C%20dramatic%20golden%20hour%20lighting%2C%20action%20and%20adventure%20vibe%2C%20clean%20cinematic%20composition%2C%20warm%20desert%20tones%20with%20motion%20blur&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    rating: 8.3,
    year: 2024,
    quality: '4K 超清',
    duration: '121分钟',
    region: '中国大陆',
    description: '昔日冠军车手张驰沦为落魄驾校教练，过着靠脸吃饭的生活。不料濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队，再闯最后一届巴音布鲁克拉力赛。面对这泼天的富贵，张驰召集老友们，再次踏上征途。',
    director: '韩寒',
    cast: ['沈腾', '范丞丞', '尹正', '张本煜'],
    tags: ['喜剧', '赛车', '运动', '剧情'],
    featured: true,
    trending: true,
    newRelease: true,
  },
  {
    id: '11',
    title: '三大队',
    titleEn: 'Endless Journey',
    slug: 'endless-journey',
    category: '剧情片',
    categorySlug: 'drama',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20police%20drama%20film%20poster%2C%20three%20detectives%20walking%20through%20rainy%20street%20at%20night%2C%20determined%20expressions%2C%20dark%20blue%20and%20warm%20streetlight%20tones%2C%20gritty%20realistic%20style%2C%20clean%20cinematic%20poster%20design&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    rating: 7.6,
    year: 2023,
    quality: '蓝光 1080P',
    duration: '132分钟',
    region: '中国大陆',
    description: '刑侦大队队长程兵带领的三大队在办理一起恶性案件的过程中意外导致嫌犯之一死亡，被判入狱。出狱后，他依然坚持以普通人身份追踪在逃嫌犯。十二年追凶路上，程兵始终没有放弃心中的正义。',
    director: '戴墨',
    cast: ['张译', '李晨', '魏晨', '曹炳琨'],
    tags: ['犯罪', '剧情', '警匪', '真实改编'],
    featured: false,
    trending: false,
    newRelease: false,
  },
  {
    id: '12',
    title: '八角笼中',
    titleEn: 'Octagonal',
    slug: 'octagonal',
    category: '剧情片',
    categorySlug: 'drama',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sports%20drama%20movie%20poster%2C%20young%20fighter%20in%20boxing%20ring%20with%20dramatic%20overhead%20lighting%2C%20determined%20expression%2C%20warm%20golden%20spotlight%20in%20darkness%2C%20inspiring%20and%20raw%20aesthetic%2C%20clean%20powerful%20composition&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    rating: 7.7,
    year: 2023,
    quality: '蓝光 1080P',
    duration: '117分钟',
    region: '中国大陆',
    description: '向腾辉倾注心血想把当地无人照料的孩子培养成才，让生活本没有出路的孩子们看到了一丝通向未来的曙光。然而，随着往日的表演视频被爆出，这些"残忍、血腥"的画面刺激了不明真相的人们的神经，一夜之间舆论发酵。',
    director: '王宝强',
    cast: ['王宝强', '陈永胜', '史彭元', '王迅'],
    tags: ['剧情', '运动', '励志', '社会'],
    featured: false,
    trending: false,
    newRelease: false,
  },
];

export const features = [
  {
    icon: 'ri-4k-line',
    title: '4K超清画质',
    description: '支持4K超高清分辨率播放，每一帧都纤毫毕现，带给您极致的视觉享受。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告纯净观影',
    description: '全程无广告打扰，纯净观影体验，让您沉浸在影视世界中不受任何干扰。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载不缓冲',
    description: '采用先进的CDN加速技术，全球节点覆盖，确保视频加载流畅不卡顿。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '海量影视资源',
    description: '收录数万部热门电影电视剧，涵盖各类题材，每日更新，总能找到您想看的。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20warm%20friendly%20expression%2C%20clean%20simple%20background%2C%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '画质真的太棒了，4K超清看大片就是不一样，而且真的没有广告，体验非常好！',
    rating: 5,
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20clean%20simple%20background%2C%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '追剧神器！更新速度很快，热播剧都能第一时间看到，加载也很流畅。',
    rating: 5,
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20photo%2C%20friendly%20expression%2C%20clean%20simple%20background%2C%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '种类很齐全，从最新的院线大片到经典老片都能找到，分类也很清晰方便查找。',
    rating: 4,
  },
];